import React, { Component, Fragment } from 'react';
import { getRequestParams, getBaseApiUrl } from '../../../src/helpers/globalfunctions.js';
import { ChangePasswordComponent } from '../ChangePasswordComponent';
import { ClockComponent } from '../ClockComponent';
import { SelectBox } from 'devextreme-react/select-box';
import  secureLocalStorage  from  "react-secure-storage";

export class TopUserSetupComponent extends Component {
    static displayName = TopUserSetupComponent.name;

    constructor(props) {
        super(props);
        let accountName = secureLocalStorage.getItem("session_accountname");
        if (accountName !== null && accountName !== undefined && accountName.length > 0) {
            accountName = accountName.toUpperCase();
        } else {
            accountName = "";
        }
        this.state = {
            multipleUserAccess: [],
            childUserId: 0,
            childUserGuid: null,
            accountName: accountName
        }
    }

    componentDidMount() {
        this.getUserMultipleAccountAccess();
    }

    getUserMultipleAccountAccess = async () => {
        try {
            let parentUserId = secureLocalStorage.getItem('session_parentUserId');
            if (parentUserId !== null && parentUserId !== undefined && Number(parentUserId) > 0) {
                const requestParams = getRequestParams('GET');
                const response = await fetch(getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) + 'Users/MultipleAccountDetails' + '/' + parentUserId, requestParams)
                const data = await response.json();
                this.setState({
                    multipleUserAccess: data.payload != null ? data.payload : [],
                });
            }
        } catch (err) {
            console.log("Error in " + this.displayName + ".getUserMultipleAccountAccess function", err);
        }
    }

    handleLogout = async (e) => {
        e.preventDefault();
        try {
            const requestParams = getRequestParams('GET');
            let userId = parseInt(secureLocalStorage.getItem("session_userId"));
            let loginHistoryId = parseInt(secureLocalStorage.getItem("session_LoginHistoryId"));
            const response = await fetch(getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) + 'authentication/logout/' + userId + '/' + loginHistoryId, requestParams);
            secureLocalStorage.clear();
            window.location.href = "/";
        } catch (err) {
            console.log("Error in " + this.displayName + ".handleLogout function", err);
        }
    }

    handleValidSwitch = async (parentUserId, userId) => {
        try {
            const requestParams = getRequestParams("GET");
            const response = await fetch(getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) + 'Users/ValidSwitch/' + parentUserId + '/' + userId, requestParams);
            const redirectdata = await response.json();
            return redirectdata.isSuccess;
        } catch (err) {
            console.log("Error in " + this.displayName + ".handleValidSwitch function", err);
        }
    }

    handleAccountInputChange = async (data) => {
        try {
            if (data.selectedItem != null) {
                let parentUserId = secureLocalStorage.getItem("session_parentUserId");

                let retFlag = await this.handleValidSwitch(parentUserId, data.selectedItem.userId)
                if (retFlag === true) {
                    const requestParams = getRequestParams("GET");
                    const response = await fetch(getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) + 'RedirectUser/Insert/' + data.selectedItem.userName, requestParams);
                    const redirectdata = await response.json();
                    if (redirectdata.payload != null) {
                        window.location.href = "/redirect/?userguid=" + redirectdata.payload.token
                    }
                    else if (redirectdata.token != null) {
                        window.location.href = "/redirect/?userguid=" + redirectdata.token
                    }
                }
            }
            else {
                this.setState({
                    childUserId: 0,
                    childUserGuid: null
                });
            }
        } catch (err) {
            console.log("Error in " + this.displayName + ".handleAccountInputChange function", err);
        }
    }

    openchangesPasswordModel = (e) => {
        e.preventDefault();
        this.refs.changepasswordcomponent.showModal();
    }

    displayExpr= (item) => {  
        if (item != null)  {
            return item.accountName + " [" + item.userName + "]";
        }
        else {
            return "Select Account";
        }
    }

    handleBackToMainAccount = async () => {
        try {
            const requestParams = getRequestParams("GET");
            let parentUserName = secureLocalStorage.getItem("session_parentUserName");
            const response = await fetch(getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) + 'RedirectUser/Insert/' + parentUserName, requestParams);
            const redirectdata = await response.json();
            if (redirectdata.payload != null) {
                window.location.href = "/redirect/?userguid=" + redirectdata.payload.token
            }
        } catch (err) {
            console.log("Error in " + this.displayName + ".handleBackToMainAccount function", err);
        }
    }

    render() {
        return (
            <Fragment>
                <li className={this.state.multipleUserAccess.length > 0 ? "displayBlock" : "displayNone"}>
                    <button type="submit" className="btn btn-success" tabIndex="4" onClick={this.handleBackToMainAccount}>
                        <span title="Back to main account"><i className="far fa-arrow-alt-circle-left"></i></span>                        
                    </button>
                </li>
                <li className="ml-1">
                    <SelectBox
                        dataSource={this.state.multipleUserAccess.length > 0 ? this.state.multipleUserAccess : []}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select Account"
                        name="userId"
                        defaultValue={0}
                        value={this.state.childUserId}
                        //displayExpr='accountName'
                        displayExpr={this.displayExpr}
                        valueExpr='userId'
                        onSelectionChanged={this.handleAccountInputChange}
                        showClearButton={false}
                        disable={false}
                        visible={this.state.multipleUserAccess.length > 0 ? true : false}
                        searchEnabled={true}
                        width={280}
                    />
                </li>    
                <li className="dropdown mr-0 user-profile ml-1">                                        
                    <a href="#" data-toggle="dropdown" className="dropdown-toggle nav-link-user">
                        <div className="d-sm-inline-block d-lg-inline-block pr-2 text-white">{this.state.accountName}</div>
                        <img alt="image" src="./assets/img/avatar/avatar-1.png" className="rounded-circle mr-1 border" style={{width: "20px"}} />
                    </a>
                    <div className="dropdown-menu dropdown-list dropdown-menu-right rounded-vlg">
                        <div className="dropdown-header pb-0">
                            Hey {secureLocalStorage.getItem('session_userName')}!
                        </div>
                        <div className="text-center mt-3 mb-3">
                            <figure className="avatar mr-2 avatar-xl">
                                <img src="../assets/img/avatar/avatar-1.png" alt="..." />
                                <i className="avatar-presence online"></i>
                            </figure>
                        </div>
                        <a href="#" className="dropdown-item has-icon" onClick={(e) => { this.openchangesPasswordModel(e) }}>
                            <i className="fas fa-lock-open"></i> Change Password
                        </a>
                        <a href="#" onClick={this.handleLogout} className="dropdown-item has-icon mb-2">
                            <i className="fas fa-sign-out-alt"></i> Logout
                        </a>
                        <div className="dropdown-footer text-center pt-0 pb-2"><ClockComponent /></div>
                    </div>
                </li>
                <ChangePasswordComponent ref="changepasswordcomponent" />
            </Fragment>
        );
    }
}